import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonHttpRequestInterceptor } from './clients/CommonHttpRequestInterceptor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './common/material.module';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SpinnerInterceptorService } from './services/spinner-interceptor.service';
import { DataGridComponent } from './components/data-grid/data-grid.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { DeleteComponent } from './components/delete-component/delete-component.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { SpinnersAngularModule } from 'spinners-angular';
import { SpinnerComponent } from './animation/spinner-animation/spinner.component';
import { DashboardPageComponent } from './pages/dashboard-page/dashboard-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LoginComponent } from './pages/account-management-page/login/login.component';
import { ForgotPasswordComponent } from './pages/account-management-page/forgot-password/forgot-password.component';
import { VerificationCodeComponent } from './pages/account-management-page/forgot-password/verification-code/verification-code.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { EmailVerificationComponent } from './pages/account-management-page/email-verification/email-verification.component';
import { MatSlideToggleModule,} from '@angular/material/slide-toggle';
import { ServicePageComponent } from './pages/service-page/service-page.component';
import { ShiftAddPopupComponent } from './components/pop-ups/shift-add-popup/shift-add-popup.component';
import { ShiftPageComponent } from './pages/shift-page/shift-page.component';
import { TermAddPopupComponent } from './components/pop-ups/term-add-popup/term-add-popup.component';
import { TermEditPopupComponent } from './components/pop-ups/term-edit-popup/term-edit-popup.component';
import { TermPageComponent } from './pages/term-page/term-page.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { ShiftTemplateConfigPopupComponent } from './components/pop-ups/shift-template-config-popup/shift-template-config-popup.component';
import { MembershipsPageComponent } from './pages/memberships-page/memberships-page.component';
import { HolidayDayPopupComponent } from './components/pop-ups/holiday-add/holiday-day-popup.component';
import { ServiceCategoryPopupComponent } from './components/pop-ups/service-category-popup/service-category-popup.component';
import { UsersPageComponent } from './pages/users-page/users-page.component';
import { UserPopupComponent } from './components/pop-ups/user-popup/user-popup.component';
import { ConfigurationPageComponent } from './pages/configuration-page/configuration-page.component';
import { GenericModalComponent } from './components/modals/generic-modal/generic-modal.component';
import { SwipeableModalComponent } from './components/modals/generic-modal/swipeable-modal/swipeable-modal.component';
import { ModalContainerComponent } from './components/modals/generic-modal/generic-modal-container/modal-container.component';
import { GenericSideModalComponent } from './components/modals/generic-side-modal/generic-side-modal.component';
import { GenericSideModalContainerComponent } from './components/modals/generic-side-modal/generic-side-modal-container/generic-side-modal-container.component';
import { SvgLoadMorphAnimationComponent } from './animation/svg-load-morph-animation/svg-load-morph-animation.component';
import { SvgBgAnimationComponent } from './animation/svg-bg-animation/svg-bg-animation.component';
import { TruncatePipe } from './pipes/truncate';
import { register } from 'swiper/element/bundle';
import { ServicePopupComponent } from './components/pop-ups/service-popup/service-popup.component';

register();

@NgModule({
  declarations: [
    AppComponent,
    DataGridComponent,
    DeleteComponent,
    SpinnerComponent,
    DashboardPageComponent,
    HomePageComponent,
    LoginComponent,
    ForgotPasswordComponent,
    VerificationCodeComponent,
    EmailVerificationComponent,
    TermPageComponent,
    TermAddPopupComponent,
    TermEditPopupComponent,
    ServicePageComponent,
    ShiftPageComponent,
    ShiftAddPopupComponent,
    ShiftTemplateConfigPopupComponent,
    ServiceCategoryPopupComponent,
    UsersPageComponent,
    UserPopupComponent,
    MembershipsPageComponent,
    ServiceCategoryPopupComponent,
    HolidayDayPopupComponent,
    ConfigurationPageComponent,
    GenericModalComponent,
    SwipeableModalComponent,
    ModalContainerComponent,
    GenericSideModalComponent,
    GenericSideModalContainerComponent,
    SvgLoadMorphAnimationComponent,
    SvgBgAnimationComponent,
    TruncatePipe,
    ServicePopupComponent,
  ],
  imports: [
    BrowserModule,
    MatExpansionModule,
    MatIconModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatNativeDateModule,
    SpinnersAngularModule,
    MatTooltipModule,
    MatSlideToggleModule,
    ModalModule.forRoot(),
    FullCalendarModule,
    MatSnackBarModule,
    MatTabsModule,
    MatRadioModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    })
  ],
  providers: [
    [
      { provide: HTTP_INTERCEPTORS, useClass: CommonHttpRequestInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptorService, multi: true },
      { provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    ]
  ],
  exports:[
    MaterialModule,
    DataGridComponent
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents:[
    DataGridComponent
  ]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/');
}
